import React from 'react';
export class Home extends React.Component {
    render() {
        return (
            <div className="media-box">
                <img src={this.props.imagem} alt="camiseta_geek"></img>
                <div className="nome">{this.props.nome}</div>
                <div className="preço">{this.props.preço}</div>
            </div>
        )
    }
}